"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _CodeSnippet = _interopRequireWildcard(require("../CodeSnippet"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * @deprecated Code component is deprecated. Use CodeSnippet component or inline `<code>` instead.
 */
const Code = _ref => {
  let {
    children,
    className,
    inline,
    copyable,
    numbered,
    ...props
  } = _ref;
  if (_utils.IS_DEV) {
    console.warn("Code component is deprecated. Use CodeSnippet component or inline `<code>` instead.");
  }
  if (inline) {
    return /*#__PURE__*/_react.default.createElement("code", _extends({
      className: className
    }, props), children);
  } else {
    let appearance = null;
    if (numbered) {
      appearance = _CodeSnippet.CodeSnippetBlockAppearance.NUMBERED;
    } else if (copyable) {
      appearance = _CodeSnippet.CodeSnippetBlockAppearance.LINUX_PROMPT;
    }
    return /*#__PURE__*/_react.default.createElement(_CodeSnippet.default, {
      blocks: [{
        appearance,
        code: children
      }]
    });
  }
};
Code.propTypes = {
  children: _propTypes.default.string.isRequired,
  inline: _propTypes.default.bool,
  copyable: _propTypes.default.bool,
  numbered: _propTypes.default.bool
};
var _default = exports.default = Code;